import { SavingsGoal } from '@unistocks/features/savings-goals/savings-goal';
import { SavingsGoalActions } from '@unistocks/features/savings-goals/store/savings-goals.slice';
import { useSavingsGoalsGetQuery } from '@unistocks/proxy/axios-client/SavingsGoalsQuery';
import { useAppDispatch } from '@unistocks/shared/hooks/redux-hooks';
import { t } from '@unistocks/shared/localization/index.ts';
import { HasId } from '@unistocks/types/has-id';
import { useFocusEffect, useLocalSearchParams, useNavigation } from 'expo-router';
import Head from 'expo-router/head';
import { useCallback } from 'react';

export default function SavingsGoalScreen() {
  const navigation = useNavigation();
  const dispatch = useAppDispatch();
  const { id } = useLocalSearchParams<HasId>();
  const { data: savingsGoal, isSuccess } = useSavingsGoalsGetQuery({ id });

  useFocusEffect(
    useCallback(() => {
      if (savingsGoal) {
        navigation.setOptions({ title: savingsGoal.name });
        dispatch(SavingsGoalActions.setSelectedSavingsGoalId(savingsGoal.id));
      }
    }, [dispatch, navigation, savingsGoal])
  );

  let title = t('::Menu:SavingsGoals');
  if (isSuccess) {
    title = `${savingsGoal.name} | ${title}`;
  }

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <SavingsGoal id={id} />
    </>
  );
}
